export default function getBaseConfig() {
    return {
        mounted: ($f) => {
        },
        onReload: ($f) => {
        },
        onSubmit: (formData, $f) => {
        },
        el: null,
        switchMaker: true,
    };
}
